import { render } from "./BrandSort.vue?vue&type=template&id=7ade3983"
import script from "./BrandSort.vue?vue&type=script&lang=js"
export * from "./BrandSort.vue?vue&type=script&lang=js"

import exportComponent from "/www/wwwroot/home/v-admin/node_modules/.store/vue-loader@16.8.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__